import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import utils from 'helpers/utils';
import ToolbarWrapper from 'components/templates/Wrappers/Toolbars/ToolbarWrapper/ToolbarWrapper';

const StyledSettingsBarWrapper = styled(ToolbarWrapper)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--settings-bar-wrapper-bounds-top': props.$wrapper?.boundsCum?.top ?? '0px',
      '--settings-bar-wrapper-bounds-bottom': props.$wrapper?.boundsCum?.bottom ?? '0px'
    };

    return utils.styleProps(attr, vars);
  })`
  min-height: calc(100vh - (${props => props.$css.$var('--settings-bar-wrapper-bounds-top')} + ${props => props.$css.$var('--settings-bar-wrapper-bounds-bottom')}));

  ${ComponentStyles}
`;

StyledSettingsBarWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledSettingsBarWrapper;
